export default __webpack_public_path__ + "static/media/manupatra.81f3da36.png";